import React from "react";
import { render } from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./views/Paso1/Home";
import DatosPersonales from "./views/Paso2/DatosPersonales";
import DatosLaborales from "./views/Paso3/DatosLaborales";
import FinComunicacion from "./views/Paso3/FinComunicacion";
import Oferta from "./views/Paso4/Oferta";
// import OfertaPlataPilotoSinDoc from "./views/Paso4/OfertaPlataPilotoSinDoc";
import AgenciaDeRetiro from "./views/Paso5/AgenciaDeRetiro";
import SolicitarMiTarjeta from "./views/Paso5/SolicitarMiTarjeta";
import ServiciosAdicionales from "./views/Paso6/ServiciosAdicionales";
import VerificacionDeDatos from "./views/Paso7/VerificacionDeDatos";
import CostoDeActivacion from "./views/Paso8/CostoDeActivacion";
import CostoDeActivacionError from "./views/Paso8/CostoDeActivacionError";
import TarjetaPagoPendiente from "./views/Paso9/TarjetaPagoPendiente";
import TarjetaPreAprobada from "./views/Paso9/TarjetaPreAprobada";
import CedulaRechazada from "./views/PasoFin/CedulaRechazada";
import IntenteLuego from "./views/PasoFin/IntenteLuego";
import VerificacionCelular from "./views/PasoFin/VerificacionCelular";
import NoCalifica from "./views/PasoFin/NoCalifica";
import EnProceso from "./views/PasoFin/EnProceso";
import EsCliente from "./views/PasoFin/EsCliente";
import PagoPendiente from "./views/PasoFin/PagoPendiente";
import SolicitudEnCurso from "./views/PasoFin/SolicitudEnCurso";
import "assets/css/material-react.css?v=1.10.0";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas, far);

// Importar las configuraciones de AWS
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
Amplify.configure(awsconfig);

const App = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/datos-personales" element={<DatosPersonales />} />
      <Route path="/datos-laborales" element={<DatosLaborales />} />
      <Route path="/datitos" element={<DatosLaborales />} />
      <Route path="/gracias-siisa" element={<FinComunicacion />} />
      {/* <Route
        path="/oferta/plata/piloto-sindoc"
        element={<OfertaPlataPilotoSinDoc />}
      /> */}
      <Route path="/oferta/:tipoTarjeta" element={<Oferta />} />
      <Route path="/agencia-de-retiro" element={<AgenciaDeRetiro />} />
      <Route
        path="/solicitar-mi-tarjeta/:tipoTarjeta"
        element={<SolicitarMiTarjeta />}
      />
      <Route path="/adicionales" element={<ServiciosAdicionales />} />
      <Route path="/verificacion-celular" element={<VerificacionDeDatos />} />
      <Route
        path="/costo-de-activacion" ///:transactionId?/:document?/:idLead?/:pagoAnticipado?"
        element={<CostoDeActivacion />}
      />
      <Route
        path="/error-mp/:transactionId?/:document?/:idLead?/:pagoAnticipado?"
        element={<CostoDeActivacionError />}
      />
      <Route path="/pendiente-mp" element={<TarjetaPagoPendiente />} />
      <Route path="/felicitaciones" element={<TarjetaPreAprobada />} />
      <Route path="/gracias" element={<TarjetaPreAprobada />} />
      <Route path="/redes-de-cobranza" element={<TarjetaPreAprobada />} />
      <Route path="/solicitud-enviado" element={<TarjetaPreAprobada />} />
      <Route path="/rechazada" element={<CedulaRechazada />} />
      <Route path="/error-inesperado" element={<IntenteLuego />} />
      <Route
        path="/solicitud-en-proceso-de-aprobacion"
        element={<EnProceso />}
      />
      <Route path="/es-cliente" element={<EsCliente />} />
      <Route path="/no-califica" element={<NoCalifica />} />
      <Route path="/pago-pendiente" element={<PagoPendiente />} />
      <Route
        path="/intente-mas-tarde-siisa-equifax"
        element={<IntenteLuego />}
      />
      <Route path="/intente-mas-tarde" element={<IntenteLuego />} />
      <Route
        path="/verificacion-celular-intenta-nuevamente"
        element={<VerificacionCelular />}
      />
      <Route path="/solicitud-en-curso" element={<SolicitudEnCurso />} />
    </Routes>
  );
};

render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root"),
);
